const PLANOS_VISIVEIS = ['professional', 'business', 'enterprise'];
const ESTADOS_VISIVEIS = ['active', 'trialing'];

/** Normaliza uma cidade para casar/dropdown: minúsculas, sem acentos, trim. */
export function normalizarCidade(s: string): string {
  return (s ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();
}

/** Espelha o gate das RPCs: só Professional+ com subscrição ativa aparece. */
export function empresaVisivelNoMarketplace(plano: string | null, status: string | null): boolean {
  return !!plano && PLANOS_VISIVEIS.includes(plano) && !!status && ESTADOS_VISIVEIS.includes(status);
}
